export const attachJwtToCallback = (authCallback: string, jwt: string, refreshToken: string) => {
    return `${authCallback}/${jwt}/${refreshToken}`;
};

export const attachCustomTokenToCallback = (authCallback: string, customToken: string) => {
    return `${authCallback}/${customToken}`;
};
